<script>
export default {
  name: "driverRecharge",
  props: {
    driverData: {
      default: () => {
        return {};
      },
    }
  },
  data() {
    return {
      loading:false,
      form: {
        fee: ''
      },
      rules: {
        fee: [{required: true, message: '请输入充值金额', trigger: 'blur'}]
      }
    }
  },
  methods: {
    async actionFn() {
      const valid = await this.$refs.form.validate().catch((err) => err);
      const url = "/api/v1/manage/driver/recharge"
      if (typeof valid === "boolean" && valid) {
        this.loading = true;
        const {code} = await this.$axios.post(url, {
          ...this.form,
          id: this.driverData.id
        });
        this.loading = false;
        if (code === 1) {
          this.$message.success("充值成功");
          this.$emit("handClose");
        }

      }
    }
  }
}
</script>

<template>
  <div>
    <el-form :model="form" :rules="rules" ref="form" label-width="0px">
      <el-form-item prop="fee">
        <el-input
            type="text"
            v-input-filter="{ min: 1, max: 999, precision: 0 }"
            placeholder="请输入充值金额"
            v-model="form.fee"
        ></el-input>
      </el-form-item>
      <el-form-item>
       <span class="util-remark">充值的金额，可用于司机代平台收款的扣费</span>
      </el-form-item>
      <el-form-item label-width="0px">
        <div class="main-form-btn">
          <el-button @click="$emit('handClose')">取消</el-button>
          <el-button type="primary" @click="actionFn" :loading="loading"
          >充值
          </el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>

</template>

<style scoped lang="less">

</style>